<template>
  <v-alert :class="[noMargin && 'ma-0']" text :dismissible="dismissible" v-model="displayMessage" type="error">
    <span>{{ message }}</span>
    <ul>
      <li v-for="error in validationMessages">
        {{ error }}
      </li>
    </ul>
  </v-alert>
</template>
<script>
export default {
  props: {
    message: String,
    validationMessages: Array,
    dismissible: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayMessage : {
      get() { return !!this.message },
      set(value) { this.$emit('update:message', value || null)}
    }
  }
};
</script>
